import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import Brand1 from '../assets/partner-1.webp';
import Brand2 from '../assets/partner-2.webp';
import Brand3 from '../assets/partner-3.webp';
import Brand4 from '../assets/partner-4.webp';
import Brand5 from '../assets/partner-5.svg';
import Brand6 from '../assets/partner-6.svg';
import Brand7 from '../assets/partner-7.svg';
import Brand8 from '../assets/partner-8.webp';
import Brand9 from '../assets/partner-9.svg';

import "swiper/css";
import "swiper/css/pagination";

const Partners = () => {
    return (
        <section className="section partner">
            <Swiper
                modules={[Pagination, Autoplay]}
                spaceBetween={30}
                className="partner-img"
                slidesPerView={1}
                pagination={{ clickable: true }}
                autoplay={{ delay: 3000 }}
                breakpoints={{
                    768: { slidesPerView: 2 },
                    1024: { slidesPerView: 4 },
                }}
            >
                <SwiperSlide>
                    <img src={Brand1} alt="brand1" />
                </SwiperSlide>
                <SwiperSlide>
                    <img src={Brand2} alt="brand1" />
                </SwiperSlide>
                <SwiperSlide>
                    <img src={Brand3} alt="brand1" />
                </SwiperSlide>
                <SwiperSlide>
                    <img src={Brand4} alt="brand1" />
                </SwiperSlide>
                <SwiperSlide>
                    <img src={Brand5} alt="brand1" />
                </SwiperSlide>
                <SwiperSlide>
                    <img src={Brand6} alt="brand1" />
                </SwiperSlide>
                <SwiperSlide>
                    <img src={Brand7} alt="brand1" />
                </SwiperSlide>
                <SwiperSlide>
                    <img src={Brand8} alt="brand1" />
                </SwiperSlide>
                <SwiperSlide>
                    <img src={Brand9} alt="brand1" />
                </SwiperSlide>
            </Swiper>
        </section>
    );
};

export default Partners;